import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SegundaInstanciaService } from '../../../services/segunda-instancia.service';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-modal-agregar-entidad-segunda-instancia',
  templateUrl: './modal-agregar-entidad-segunda-instancia.component.html',
  styleUrl: './modal-agregar-entidad-segunda-instancia.component.scss'
})
export class ModalAgregarEntidadSegundaInstanciaComponent implements OnInit {

  @ViewChild('modalAgregarEntidadSegundaInstanciaButton')
  modalAgregarEntidadSegundaInstanciaButton!: ElementRef;

  @Output() guardadoEntidad = new EventEmitter<boolean>();
  title='Agregar entidad segunda instancia'
  submitButton='Guardar entidad'
  fieldsAgregarEntidadSegundaInstancia: FormField[] = [];
  formGroup?: FormGroup;
  error?: string;

  // Multilenguaje
  modalText: any = {};
  constructor(
    private segundaInstanciaService: SegundaInstanciaService,
    private alertaModalService: AlertaModalService,
    private translate: TranslateService
  ){}

  ngOnInit(): void {
    this.translate.stream('modal-segunda-instancia').subscribe(text => {
      this.modalText = text;
      this.creacionFormulario();
    });
  }

  creacionFormulario(){
    this.fieldsAgregarEntidadSegundaInstancia = [
      {
        name: 'nombreEntidad',
        label: this.modalText['nombre'],
        type: 'text',
        placeholder: this.modalText['placeholder-nombre'],
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.minLength(5), Validators.maxLength(50)],
        errorMessages: {
          required: this.modalText['nombre-required'],
          minlength: this.modalText['nombre-minlength'],
          maxlength: this.modalText['nombre-maxlength'],
        },
      },
      {
        name: 'estado',
        label: this.modalText['estado'],
        type: 'select',
        required: true,
        width: '6',
        options: [
          { Id: 1, Nombre: this.modalText['activo'] },
          { Id: 0, Nombre: this.modalText['inactivo'] },
        ],
        validation: [Validators.required],
        errorMessages: {
          required: this.modalText['estado-required'],
        },
      },
    ]
  }

  onSubmitCrearEntidadSegundaInstancia(form: FormGroup){
    this.segundaInstanciaService.almacenarEntidadSegundaInstancia(
      form.get('nombreEntidad')?.value, form.get('estado')?.value
    ).subscribe({
      next: resp => {
        form.reset();
        this.guardadoEntidad.emit(true)
      },
      error: error => {
        form.reset();
        this.guardadoEntidad.emit(false)
      }
    })
  }

  restablecerForm(){
    if (this.formGroup != undefined) {
      this.formGroup.reset();
    }
    this.abrirCerrarModal();
  }

  onChangeForm(form: FormGroup) {
    this.formGroup = form;
  }

  abrirCerrarModal() {
    this.modalAgregarEntidadSegundaInstanciaButton.nativeElement.click();
  }
}
